export class Scale {
  public id: number;
  public factor: number;
  public name: string;

  constructor(id: number, factor: number, name: string) {
    this.id = id;
    this.factor = factor;
    this.name = name;
  }
}
